import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';
import { IResponse } from 'src/app/core/interfaces/response.interface';
import { IRoleSelector } from 'src/app/core/interfaces/role-selector.interface';
import { AuthService } from 'src/app/services/auth.service';
import { ErrorService } from 'src/app/services/error.service';
import { environment } from 'src/environments/environment';
import * as RoleSelectorActions from '../actions/role-selector.actions';

@Injectable()
export class RoleSelectorEffects {
  constructor(
    private actions$: Actions,
    private http: HttpClient,
    private errorService: ErrorService,
    private authService: AuthService
  ) {}

  getRoleSelector$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoleSelectorActions.readRoleSelector),
      switchMap(({ payload }) => {
        return this.http
          .get<IResponse<IRoleSelector[]>>(
            `${environment.apiUrl}/roles/selector`,
            {
              params: {
                search: payload.searchText,
              },
            }
          )
          .pipe(
            mergeMap((response) => {
              return of(
                RoleSelectorActions.roleSelectorRead({
                  payload: { rolesSelector: response.data },
                })
              );
            }),
            catchError((error) => {
              return of(
                RoleSelectorActions.roleSelectorFail({
                  payload: { error: this.errorService.mapError(error) },
                })
              );
            })
          );
      })
    )
  );
}
